<main>
  <div class="nordic-blue-900-text rounded-large pr-large-x pr-small-y border">
    <cms-rich-text
      *ngFor="let article of content$ | async; let isLast = last"
      data-testid="child-safety-notice-content"
      [content$]="article | finToObservable"
      [headerStyles]="['font-heading-4']"
    ></cms-rich-text>
    <div>
      <fcom-checkbox
        [id]="'child-safety-notice-checkbox'"
        [name]="'child-safety-notice-checkbox'"
        data-testid="child-safety-notice-checkbox"
        (change)="onCheckboxChange($event)"
      >
        <span class="font-body-1 medium-type">
          {{ 'kidsInBusinessNotification.checkboxLabel' | finLocalization }}
        </span>
      </fcom-checkbox>
    </div>
    @if (showErrorMessage$ | async) {
      <div #errorMessage class="pr-small-t font-body-1 error-900-text" data-testid="error-message">
        {{ 'MMB.checkIn.funnel.steps.childSafetyNotice.errorMessage' | finLocalization }}
      </div>
    }
  </div>
</main>
<fcom-cta-button
  [title]="'MMB.checkIn.funnel.steps.childSafetyNotice.button.ctaAction' | finLocalization"
  [position]="ButtonPosition.GRID_FULL"
  (buttonClicked)="continueToNextStep()"
>
  <span class="gray-50-text" data-testid="apis-helper-description"
    >{{ 'MMB.checkIn.funnel.steps.childSafetyNotice.button.description' | finLocalization }}
  </span>
</fcom-cta-button>
